import React, { useState } from "react";
import { Popconfirm, Input } from "antd";

import images from "../../assets";
import {
  PrimaryButton,
  PendingButton,
  ApprovedButton,
  RejectedButton,
} from "../button";

const { TextArea } = Input;

export default function UserProfilePhotoBox({
  galleryData,
  userimg,
  userimgoriginal,
  updateProfile,
  status,
  ...props
}) {
  const [rejectOpen, setRejectOpen] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const [rejectLoading, setRejectLoading] = useState(false);

  const handleApprove = () => {
    const updatedGalleryData = galleryData?.map((img) =>
      img?.originalUrl === userimgoriginal ? { ...img, status: "active" } : img
    );
    updateProfile(updatedGalleryData, "approved");
  };

  const handleRejectConfirm = async () => {
    if (!rejectReason.trim()) return;
    try {
      setRejectLoading(true);
      const updatedGalleryData = galleryData?.map((img) =>
        img?.originalUrl === userimgoriginal
          ? { ...img, status: "rejected" }
          : img
      );
      // Pass rejection reason as 3rd argument
      updateProfile(updatedGalleryData, "rejected", rejectReason.trim());
      setRejectOpen(false);
      setRejectReason("");
    } finally {
      setRejectLoading(false);
    }
  };

  return (
    <div
      {...props}
      className="bg-white rounded-2xl border border-primary50 flex-col flex"
    >
      <div className="flex-col justify-start items-start gap-4 flex p-4">
        <img
          className="aspect-square w-full min-w-[300px] rounded-xl object-cover"
          src={userimg}
          alt="img"
        />

        <div className="w-full items-center gap-2 flex">
          <div>Status:</div>
          {status === "active" || status === "approved" ? (
            <ApprovedButton />
          ) : status === "pending" ? (
            <PendingButton />
          ) : (
            <RejectedButton />
          )}
        </div>

        <PrimaryButton
          style={{ width: "100%", background: "#310048" }}
          text={"Edit Photo"}
          iconalign="left"
          icon={images.editPhotoIcon}
        />
      </div>

      <div className="bg-[#f5f6f7] w-full rounded-bl-2xl rounded-br-2xl p-4 justify-center items-center gap-5 flex flex-col">
        <Popconfirm
          title="Approve photo?"
          description="Are you sure to approve this photo?"
          onConfirm={handleApprove}
          okText="Yes"
          cancelText="No"
        >
          <PrimaryButton
            style={{ background: "#17c964" }}
            text="Approve"
            iconalign="left"
            icon={images.checkWhiteIcon}
          />
        </Popconfirm>

        <div className="self-stretch justify-start items-center gap-3 flex">
          <Popconfirm
            title="Reject photo?"
            open={rejectOpen}
            onOpenChange={(open) => {
              setRejectOpen(open);
              if (!open) setRejectReason("");
            }}
            description={
              <div className="flex flex-col gap-2">
                <div>Are you sure to reject? Please provide a reason:</div>
                <TextArea
                  value={rejectReason}
                  onChange={(e) => setRejectReason(e.target.value)}
                  placeholder="Enter rejection reason..."
                  autoSize={{ minRows: 3, maxRows: 5 }}
                  maxLength={300}
                />
              </div>
            }
            onConfirm={handleRejectConfirm}
            okText="Reject"
            cancelText="Cancel"
            okButtonProps={{
              disabled: !rejectReason.trim(),
              loading: rejectLoading,
            }}
          >
            <PrimaryButton
              style={{ background: "#f31260" }}
              text="Reject"
              iconalign="left"
              icon={images.rejectWhiteIcon}
            />
          </Popconfirm>

          <PrimaryButton
            style={{ background: "#f5a524" }}
            text="Queue"
            iconalign="left"
            icon={images.queueIcon}
          />
        </div>
      </div>
    </div>
  );
}
